let profile = {
    name: "profile",
    url:'/profile',
    template: '<div ui-view></div>',
}
let profile_orders = {
    name: 'profile.orders',
    url: '/orders',
    component: 'userProfileOrderlist'
}
let profile_orders_detail = {
    name: 'profile.orders.detail',
    url: '/:orderId',
    component: 'userProfileOrderdetail'
}
let profile_notification = {
    name: 'profile.notification',
    url: '/notification',
    component: "userProfileAlertlist"
}
let profile_favorites = {
    name: 'profile.favorites',
    url: '/favorites',
    component: 'userProfileFavoritlist'
}
let profile_editProfile = {
    name: 'profile.editProfile',
    url: '/editProfile',
    component: 'userProfileInfo'
}

export let profileRoute = [
    profile,
    profile_orders,
    profile_orders_detail,
    profile_notification,
    profile_favorites,
    profile_editProfile
];




// WEBPACK FOOTER //
// ./src/store-modules/app/route/profile/profile.ts